import { render, staticRenderFns } from "./pc-location.vue?vue&type=template&id=ebb893be&scoped=true&"
import script from "./pc-location.vue?vue&type=script&lang=ts&"
export * from "./pc-location.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb893be",
  null
  
)

export default component.exports